module.exports = __webpack_public_path__ + "static/media/anamika.45bced53.png";